

const EnvoieReducer = (state, action) => {
    switch (action.type) {
        case "GET_ENVOIS_START":
            return {
                ...state,
                envois: [],
                isFetching: true,
                error: false,
            };
        case "GET_ENVOIS_SUCCESS":
            return {
                ...state,
                envois: action.payload.envois,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_ENVOIS_FAILURE":
            return {
                ...state,
                envois: [],
                isFetching: false,
                error: action.payload,
            };
        case "SET_PAGE_NUMBER_SUCCESS":
            return {
                ...state,
                pageNumber: action.payload,
            }
        case "GET_ENVOIE_START":
            return {
                ...state,
                envoie: {},
                isFetchingGet: true,
                errorGet: false,
            };
        case "GET_ENVOIE_SUCCESS":
            return {
                ...state,
                envoie: action.payload.envoie,
                isFetchingGet: false,
                errorGet: false,
            };
        case "GET_ENVOIE_FAILURE":
            return {
                ...state,
                envoie: {},
                isFetchingGet: false,
                errorGet: action.payload,
            };
        case "ADD_CASE_START":
            return {
                ...state,
                historyCaseAdd: {},
                isFetchingCaseAdd: true,
                errorCaseAdd: false,
            };
        case "ADD_CASE_SUCCESS":
            return {
                ...state,
                historyCaseAdd: action.payload.historyCase,
                isFetchingCaseAdd: false,
                errorCaseAdd: false,
            };
        case "ADD_CASE_FAILURE":
            return {
                ...state,
                historyCaseAdd: {},
                isFetchingCaseAdd: false,
                errorCaseAdd: action.payload,
            };
        default:
            return { ...state };
    }
}

export default EnvoieReducer;